import React from 'react'
import { APP_PREFIX_PATH } from 'configs/AppConfig';

export class ChangelogProtectedRoute {

    static changelog = [
        {
            key: 'changelog',
            path: `${APP_PREFIX_PATH}/changelog`,
            component: React.lazy(() => import('views/app-views/changelog')),
        },
    ];

    static getNavTree() {
        return this.changelog;
    }

}

export default ChangelogProtectedRoute;
